import type { GetCompetitionsQuery, GetCompetitionsResponse } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

const GET_COMPETITIONS_LIMIT = 50

async function getCompetitions(query: GetCompetitionsQuery): Promise<GetCompetitionsResponse> {
  return requestApiJsonOrThrow<GetCompetitionsResponse>('admin/competitions', {
    params: query,
  })
}

export const competitionsQuery = (queryParams: GetCompetitionsQuery) => ({
  queryKey: ['competitions', queryParams],
  queryFn: ({ pageParam = 0 }: { pageParam?: number }) =>
    getCompetitions({
      limit: GET_COMPETITIONS_LIMIT.toString(),
      offset: pageParam.toString(),
      ...queryParams,
    }),
  getNextPageParam: (lastPage: GetCompetitionsResponse, pages: GetCompetitionsResponse[]) => {
    if (lastPage.data.length < GET_COMPETITIONS_LIMIT) return
    return pages.length * GET_COMPETITIONS_LIMIT
  },
})
